<template>
  <section class="content-section primary">
    <div class="section-title">
        <!-- <div class="section-title-line"></div> -->
        <h1>KERAMIK</h1>
        <!-- <div class="section-title-line"></div> -->
    </div>
    <div class="container">
      <article class="detailed-info">
        <p>Keramik, besteht aus natürlichen Materialien wie Ton, Feldspat, Quarz und Mineraloxiden und ist in vielerlei Hinsicht optimal für den Innen- und Außenbereich geeignet. Durch seine exzellenten Eigenschaften und die lange Lebensdauer hält die Keramik heutzutage immer häufiger Einzug in unsere Wohnräume. Bevorzugt in unsere Küchen und Terrassen. Denn dem Alleskönner Granit steht Keramik in nichts nach – oft ist es sogar noch etwas härter.  </p>
        <hr>
        <div class="image-row">
        <div class="image-row-item"><img src="https://marmor-kunze.de/static/images/material/keramik_muster1.jpg"></div>
        <div class="image-row-item"><img src="https://marmor-kunze.de/static/images/material/keramik_muster2.jpg"></div>
        <div class="image-row-item"><img src="https://marmor-kunze.de/static/images/material/keramik_muster3.jpg"></div>
        </div>
         <hr>
        <h2>Qualität von renommierten Herstellern</h2>
        <p>Neben einer hohen Kratz- und Abriebfestigkeit, Frost- und Hitzebeständigkeit und einer hohen chemischen Resistenz gegenüber chemischen Reinigungsmitteln, garantiert Keramik auch maximale Hygiene, da keinerlei Flüssigkeiten eindringen können.<br><br>Bei uns erhalten Sie unter anderem Küchenarbeitsplatten aus Keramik, die wir von renommierten Firmen wie NEOLITH, Laminam oder Cosentino beziehen. So können wir auch extrem robuste Küchenarbeitsplatten aus Keramik anbieten, die mit verblüffend dünn sind.</p>
        <hr>
        <div class="image-row">
          <div class="image-row-item"><img src="https://marmor-kunze.de/static/images/material/keramik_ambiente1.jpg"></div>
          <div class="image-row-item"><img src="https://marmor-kunze.de/static/images/material/keramik_ambiente2.jpg"></div>
          <div class="image-row-item"><img src="https://marmor-kunze.de/static/images/material/keramik_ambiente3.jpg"></div>
          <div class="image-row-item"><img src="https://marmor-kunze.de/static/images/material/keramik_ambiente4.jpg"></div>
          <div class="image-row-item"><img src="https://marmor-kunze.de/static/images/material/keramik_ambiente5.jpg"></div>
          <div class="image-row-item"><img src="https://marmor-kunze.de/static/images/material/keramik_ambiente6.jpg"></div>
        </div>
      </article>
      </div>
    </section>
</template>

<script>
export default {
  name: "Keramik",
  metaInfo: {
    title: "Keramik",
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "Keramik, besteht aus natürlichen Materialien wie Ton, Feldspat, Quarz und Mineraloxiden und ist in vielerlei Hinsicht optimal für den Innen- und Außenbereich geeignet."
      },
      {
        vmid: "keywords",
        name: "keywords",
        content:
          "Keramik, Dekton, Neolith, Naturstein, Mönchengladbach, Natursteinhandel"
      }
    ],
    links: [
      { rel: "canonical", href: "https://www.marmor-kunze.de/material/keramik" }
    ]
  }
};
</script>
j
<style>
</style>



// WEBPACK FOOTER //
// src/components/views/Keramik.vue